import log from './log';

export default {
    sys_monitor: { routerName: 'システムモニタ' },
    ...log,
};
